// export const BASEURL = "http://192.168.1.12:5000";

export const BASEURL = "https://official.seaiot.in";

// export const CHAT_BASEURL = 'https://chat.seaiot.in';
export const CHAT_BASEURL = 'http://192.168.1.3:3001';

